<template>
  <div v-if="value" style="position: relative; width: 100%;">
    <div style="color: black;">
      {{ title }}
      <v-chip class="ml-3" v-if="pro" label color="primary" x-small>
        PRO
      </v-chip>
    </div>
    <div class="d-flex flex-wrap">
      <div
        v-for="(option, i) in parsedOptions"
        :key="`${title}-option-${i}`"
        class="mr-2 d-flex align-center"
      >
        <div v-if="option.group" style="width: 100%; font-weight: bold;">
          {{ option.group }}
          <v-chip v-if="option.pro" class="ml-1 mr-1" label color="primary" x-small>
            PRO
          </v-chip>
          <v-icon size="10">mdi-arrow-right</v-icon>
        </div>
        <div v-else v-tooltip="option.explainer" style="display: flex; align-items: center;">
          <input
            type="checkbox"
            :id="identifier + i"
            @input="handleClick(option.value)"
            :checked="value.includes(option.value) || value.includes('all')"
            style="cursor: pointer;"
          />
          <label
            :for="identifier + i"
            class="ml-1"
            style="cursor: pointer;"
          >{{ option.text }}</label>
        </div>
      </div>
      <div
        class="mr-2 d-flex align-center"
      >
        <input
          type="checkbox"
          :checked="value.includes('all')"
          :id="'checkbox-all-' + identifier"
          @input="handleAll()"
        />
        <label
          :for="'checkbox-all-' + identifier"
          style="cursor: pointer;"
          class="ml-1"
        >Kaikki</label>
      </div>

      <!-- <v-checkbox
        hide-details
        v-for="(option, i) in parsedOptions"
        class="mt-0 mr-3"
        :key="`${title}-option-${i}`"
        :label="option.text.toString()"
        :input-value="value.includes(option.value) || value.includes('all')"
        @change="handleClick(option.value, $event)"
      />
      <v-checkbox
        :input-value="value.includes('all')"
        label="Kaikki"
        class="mt-0 mr-3"
        @change="handleAll"
      /> -->
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'options', 'value', 'pro'],
  data: () => ({
    id: null
  }),
  mounted() {
    this.id = Math.random()
  },
  methods: {
    handleClick(option) {
      const wasAll = this.value.includes('all')
      const value = !(this.value.includes(option) || wasAll)
      let arr
      // Chosen
      if(value) {
        // All were chosen or not all were chosen but are now
        if(wasAll || value && this.optionValues.length === this.value.length + 1) arr = ['all']
        // Not all were chosen and still aren't
        else arr = this.value.concat(option)
      } else {
        // Not chosen
        if(wasAll) arr = this.optionValues.filter(v => v !== option)
        else arr = this.value.filter(v => v !== option)
      }

      this.$emit('input', arr)
    },
    handleAll() {
      const wasAll = this.value.includes('all')
      if(wasAll) this.$emit('input', [])
      else this.$emit('input', ['all'])
    }
  },
  computed: {
    identifier() {
      return 'checkbox-' + this.id
    },
    optionValues() {
      if(typeof this.options[0] === 'object') {
        return this.options.map(v => v.value)
      } else {
        return this.options
      }
    },
    parsedOptions() {
      if(typeof this.options[0] === 'object') {
        return this.options
      } else {
        return this.options.map(option => {
          return {
            text: option,
            value: option
          }
        })
      }
    }
  }
}
</script>